module.exports = __webpack_public_path__ + "media/images/rails-lts-logo-72ef96c4f74838d3afc56183289901f4.svg";